module.exports = __webpack_public_path__ + "static/media/logoAltee.f8c8b9b9.svg";